import React, { useEffect, useState } from 'react'
import { useSelector, useDispatch } from "react-redux";
import { create , reset} from '../store/trade'
import { useNavigate } from "react-router-dom";
import { getTradesPage, getUserTags, createTag, setTradeTags } from '../store/trades/thunks';
import { createTradeReview, uploadReviewScreenshot } from '../store/journal/thunks';
// import { Link } from "react-router-dom";   
import '../styles/logtrade.css';
import '../styles/filter.css';
import axios from "axios";
import { returnInTZ } from '../utils/timezone';
import TradingSpinner from './TradingSpinner';

import {
  Flex,
  Text,
  Center,
  Heading,
  Input,
  Button,
  InputGroup,
  Checkbox,
  Stack,
  Textarea,
  AlertDialog,
  AlertDialogBody,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogContent,
  AlertDialogOverlay,
  useColorMode,
  Select,
  Box,
  FormControl,
  FormLabel,
  NumberInput,
  NumberInputField,
  NumberInputStepper,
  NumberIncrementStepper,
  NumberDecrementStepper,
  HStack,
  VStack,
  Wrap,
  WrapItem,
  Tag,
  TagLabel,
  TagCloseButton,
  Tooltip,
  Icon,
} from "@chakra-ui/react";
import { IoInformationCircleOutline } from "react-icons/io5";

import useToastNotification from "../hooks/useToastNotification";
import AccountValueSyncToggle from "./common/AccountValueSyncToggle";

export default function LogTrade({ user }) {
  const navigate = useNavigate();
  const showToast = useToastNotification();
  const dispatch = useDispatch();
  const { trade } = useSelector((state) => state.trade);
  const { error } = useSelector((state) => state.trade);
  const { info } = useSelector((state) => state.trade);
  const { success } = useSelector((state) => state.trade);
  const tradeLogged = ((trade && Object.keys(trade).length > 2) ? (true):(false));
  const [visib, setVisib] = useState(true);

  const [trade_type, setTradeType] = useState("");
  const [security_type, setSecurityType] = useState("");
  const [trade_direction, setTradeDirection] = useState("");
  const [ticker_name, setTickerName] = useState("");
  const [trade_date, setTradeDate] = useState("");
  const [expiry, setExpiry] = useState("");
  const [strike, setStrike] = useState("");
  const [buy_value, setBuyValue] = useState("");
  const [units, setUnits] = useState("");
  const [rr, setRR] = useState("1:1");
  const [pnl, setPNL] = useState("");
  const [percent_wl, setPercentWL] = useState("");
  const [fees, setFees] = useState("");
  const [comments, setComments] = useState("");
  const [selectedTagIds, setSelectedTagIds] = useState([]);
  const [newTagName, setNewTagName] = useState("");
  const [newTagColor, setNewTagColor] = useState("#3182CE");
  const tags = useSelector((state) => state.trades.tags) || [];
  const cancelRef = React.useRef();

  const [reviewPopup, setReviewPopup] = useState(false);
  const [logAnotherPopup, setLogAnotherPopup] = useState(false);
  const [reviewTradeId, setReviewTradeId] = useState(null);
  const [reviewSetupType, setReviewSetupType] = useState("");
  const [reviewFollowedPlan, setReviewFollowedPlan] = useState("");
  const [reviewEmotionalState, setReviewEmotionalState] = useState("");
  const [reviewNotes, setReviewNotes] = useState("");
  const [reviewScreenshot, setReviewScreenshot] = useState(null);

  const tradeLoading = useSelector((state) => state.trade.loading);

  const { colorMode } = useColorMode();


  const [accountValueAddEnable, setAccountValueAddEnable] = useState(true);

  // Toggle the checkbox when the user clicks
  const handleCheckboxChange = (e,type) => {
    if (type === "Add"){
      setAccountValueAddEnable(e.target.checked);  // Update the state based on the toggle
    }
  };
  
  const today = returnInTZ(new Date().toISOString());

  const format = (val1,val2) => val1 + ":" + val2;
  const [risk, setRisk] = useState("1");
  const [reward, setReward] = useState("1");

  useEffect(() => {
    dispatch(getUserTags());
  }, [dispatch]);

  useEffect(() => {
    evaluateSuccess();
  }, [success]);

  useEffect(() => {
    if(risk > 0 && reward > 0 && rr !== format(risk, reward)){
      setRR(format(risk,reward));
    }
  }, [risk, reward]); 

  useEffect(() => {
    if (rr && rr !== format(risk, reward)) {
      const [riskValue, rewardValue] = rr.split(':').map(val => parseInt(val));
      setRisk(riskValue);
      setReward(rewardValue);
    }
  }, [rr]);

  const evaluateSuccess = async () => {
    if(success === true && trade.result === "Trade Logged Successfully"){
      clearFormStates();
      showToast(trade.result);
      setReviewTradeId(trade.trade_id);
      setReviewPopup(true);
      const savedSummaryFilters = window.localStorage.getItem('SummaryFilters');
      let filter_trade_type = '';
      let filter_security_type = '';
      let filter_trade_direction = '';
      let filter_ticker_name = '';
      let filter_from_date = '';
      let filter_to_date = '';
      if (savedSummaryFilters) {
        const SummaryFilters = JSON.parse(savedSummaryFilters);
        filter_trade_type = SummaryFilters.trade_type || "";
        filter_security_type = SummaryFilters.security_type || "";
        filter_trade_direction = SummaryFilters.trade_direction || "";
        filter_ticker_name = SummaryFilters.ticker_name || "";
        filter_from_date = SummaryFilters.from_date || "";
        filter_to_date = SummaryFilters.to_date || "";
      }
      const filters = {};
      if(filter_trade_type !== ''){
        filters.trade_type = filter_trade_type;
      }
      if(filter_security_type !== ''){
        filters.security_type = filter_security_type;
      }
      if(filter_trade_direction !== ''){
        filters.trade_direction = filter_trade_direction;
      }
      if(filter_ticker_name !== ''){
        filters.ticker_name = filter_ticker_name;
      }
      if(filter_from_date !== '' || filter_to_date !== ''){
        if (filter_from_date !== '' && filter_to_date !== ''){
          filters.from_date = filter_from_date;
          filters.to_date = filter_to_date;
        }else if (filter_from_date !== '' && filter_to_date === ''){
          filters.from_date = filter_from_date;
          filters.to_date = today;
        }
        else if (filter_from_date === '' && filter_to_date !== ''){
          filters.from_date = "1900-01-01";
          filters.to_date = filter_to_date;
        }
      }
      filters.page = 1;
      filters.numrows = 100;
      await dispatch(getTradesPage({ filters }));
      setSearchValue('');
      setSelectedValue('');
      setIsDropdownOpen(false);
    }
  }
  useEffect(() => {
    evaluateError();
  }, [error]); 

  const evaluateError = () => {
    if(error === true){
      showToast(info.response.data.result, { status: "error" });
    }
  }
  useEffect(() => {
    const savedTradeInfo = window.localStorage.getItem('tradeInfo');
    if (savedTradeInfo) {
      const tradeInfo = JSON.parse(savedTradeInfo);
      setTradeType(tradeInfo.trade_type || "");
      setSecurityType(tradeInfo.security_type || "");
      setTradeDirection(tradeInfo.trade_direction || "");
      setTickerName(tradeInfo.ticker_name || "");
      setTradeDate(tradeInfo.trade_date || "");
      setExpiry(tradeInfo.expiry || "");
      setStrike(tradeInfo.strike || "");
      setBuyValue(tradeInfo.buy_value || "");
      setUnits(tradeInfo.units || "");
      setRR(tradeInfo.rr || "1:1");
      setPNL(tradeInfo.pnl || "");
      setPercentWL(tradeInfo.percent_wl || "");
      setFees(tradeInfo.fees || "");
      setComments(tradeInfo.comments || "");
      // Clear the saved info after loading it
      //window.localStorage.removeItem('userInfo');
    }
  }, []); // Empty dependency array means this runs once on mount

  function clearFormStates() {
    setTradeType("");
    setSecurityType("");
    setTradeDirection("");
    setTickerName("");
    setSelectedValue("");
    setSearchValue("");
    setTradeDate("");
    setExpiry("");
    setStrike("");
    setBuyValue("");
    setUnits("");
    setRR("1:1");
    setPNL("");
    setPercentWL("");
    setFees("");
    setComments("");
    setRisk("1");
    setReward("1");
    setSelectedTagIds([]);
    setNewTagName("");
    setNewTagColor("#3182CE");
    window.localStorage.removeItem('tradeInfo');
  }

  const changeShowOptions = (e) => {
    const choiceOptions = document.getElementById("optionsSelection");
    if (choiceOptions.value === "Shares"){
      setVisib(false);
      setExpiry("");
      setStrike("");
    }else if (choiceOptions.value === "Options"){
      setVisib(true);
      setExpiry("");
      setStrike("");
    }

  }

  const handleAddTag = async () => {
    if (newTagName.trim() === "") return;
    const result = await dispatch(createTag({ name: newTagName.trim(), color: newTagColor }));
    if (result.payload && result.payload.tag_id) {
      setSelectedTagIds([...selectedTagIds, result.payload.tag_id]);
      await dispatch(getUserTags());
    }
    setNewTagName("");
    setNewTagColor("#3182CE");
  };

  const handleToggleTag = (tagId) => {
    if (selectedTagIds.includes(tagId)) {
      setSelectedTagIds(selectedTagIds.filter(id => id !== tagId));
    } else {
      setSelectedTagIds([...selectedTagIds, tagId]);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const tradeInfo = {
      trade_type,
      security_type,
      trade_direction,
      ticker_name,
      trade_date,
      expiry,
      strike,
      buy_value,
      units,
      rr,
      pnl,
      percent_wl,
      fees,
      comments
    };
    const result = await dispatch(
      create({
        accountValueAddEnable,
        trade_type,
        security_type,
        trade_direction,
        ticker_name,
        trade_date,
        expiry,
        strike,
        buy_value,
        units,
        rr,
        pnl,
        percent_wl,
        fees,
        comments
      })
    );
    // Set tags on the newly created trade
    if (result.payload && result.payload.trade_id && selectedTagIds.length > 0) {
      await dispatch(setTradeTags({ trade_id: result.payload.trade_id, tag_ids: selectedTagIds }));
    }
    window.localStorage.setItem('tradeInfo', JSON.stringify(tradeInfo));
  }

  const handleClear = (e) => {
    e.preventDefault();
    clearFormStates();
  }

  const handleCancel = async (e) => {
    e.preventDefault();
    clearFormStates();
    navigate("/summary");
    const filters = {};
    filters.page = 1;
    filters.numrows = 100;
    await dispatch(getTradesPage({ filters }));
    setSearchValue('');
    setSelectedValue('');
    setIsDropdownOpen(false);
  }

  const handleAnswerYes = (e) => {
    e.preventDefault();
    setLogAnotherPopup(false);
    dispatch(
      reset()
    );
    clearFormStates();
    setAccountValueAddEnable(true);
    navigate("/logTrade");
  }

  const handleAnswerNo = (e) => {
    e.preventDefault();
    setLogAnotherPopup(false);
    dispatch(
      reset()
    );
    clearFormStates();
    navigate("/summary");
  }

  const handleSubmitReview = async (e) => {
    e.preventDefault();
    const reviewResult = await dispatch(
      createTradeReview({
        trade_id: reviewTradeId,
        setup_type: reviewSetupType || null,
        followed_plan: reviewFollowedPlan === "" ? null : reviewFollowedPlan === "true",
        emotional_state: reviewEmotionalState || null,
        notes: reviewNotes || null,
      })
    );
    if (reviewScreenshot && reviewResult.payload && reviewResult.payload.trade_review_id) {
      await dispatch(
        uploadReviewScreenshot({
          trade_review_id: reviewResult.payload.trade_review_id,
          selectedFile: reviewScreenshot,
        })
      );
    }
    setReviewPopup(false);
    clearReviewStates();
    showToast("Trade Review Saved Successfully");
    setLogAnotherPopup(true);
  }

  const handleSkipReview = () => {
    setReviewPopup(false);
    clearReviewStates();
    setLogAnotherPopup(true);
  }

  const clearReviewStates = () => {
    setReviewTradeId(null);
    setReviewSetupType("");
    setReviewFollowedPlan("");
    setReviewEmotionalState("");
    setReviewNotes("");
    setReviewScreenshot(null);
  }

  useEffect(() => {
    calculatePercent();
  }, [pnl, buy_value, units, fees]);

  const calculatePercent = () => {
    const pnlFloat=parseFloat(pnl);
    const buyValueFloat=parseFloat(buy_value);
    const unitsFloat=parseFloat(units);
    // TRADE-321: subtract fees so the previewed % matches the value the
    // backend will store (pnl is auto-net on create).
    const feesFloat=parseFloat(fees);
    const netPnl = !isNaN(feesFloat) && feesFloat > 0 ? pnlFloat - feesFloat : pnlFloat;
    if (!isNaN(netPnl) && !isNaN(buyValueFloat) && buyValueFloat !== 0 && !isNaN(unitsFloat) && unitsFloat !== 0) {
      setPercentWL(((netPnl/(buyValueFloat*unitsFloat)*100).toFixed(2)));
    }else{
      setPercentWL("");
    }
  }

  const [searchValue, setSearchValue] = useState('');
  const [searchResults, setSearchResults] = useState([]);
  const [selectedValue, setSelectedValue] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);


  useEffect(() => {
    const fetchSearchResults = async () => {
      setIsLoading(true);
      const response = await axios.get(`https://ticker-2e1ica8b9.now.sh/keyword/${searchValue}`);
      const topResults = response.data.map(f => [f.symbol + ", " + f.name]);
      setSearchResults(topResults);
      setIsLoading(false);
    };

    if (searchValue) {
      fetchSearchResults();
      setIsDropdownOpen(true);
    } else {
      setSearchResults([]);
      setIsDropdownOpen(false);
    }
  }, [searchValue]);

  const handleInputChange = (event) => {
    setSelectedValue('');
    setSearchValue(event.target.value);
    setTickerName(event.target.value);
  };

  const handleInputClick = (event) => {
    setIsDropdownOpen(!isDropdownOpen);
  };

  const handleSelection = (selection) => {
    const selectionString = selection[0];
    const index = selectionString.indexOf(",");
    const newTicker = selectionString.substring(0,index);
    setSelectedValue(newTicker);
    setTickerName(newTicker);
    setIsDropdownOpen(false);
  };

  /* need to parse out ticker and send it to handleSelection */
  const searchResultItems = searchResults.map((result) => (
    <li key={result} onClick={() => handleSelection(result)}> 
      {result}
    </li>
  ));

  // grabbing current date to set a max to the birthday input
  const currentDate = new Date();
  let [month, day, year] = currentDate.toLocaleDateString().split("/");
  // input max field must have 08 instead of 8
  month = month.length === 2 ? month : "0" + month;
  day = day.length === 2 ? day : "0" + day;
  const maxDate = year + "-" + month + "-" + day;

  return (
    <Flex
      flexDirection="column"
      minHeight="100vh"
      backgroundColor={colorMode === 'light' ? "gray.200" : "gray.800"}
      justifyContent="center"
      alignItems="center"
      overflow="auto"
      pt="20px"
      pb="40px"
    >
      <VStack pt={2} spacing={0}>
        <Box minW={{ base: "90%", md: "468px" }} maxW="650px" rounded="lg" overflow="hidden" boxShadow="sm">
        {tradeLoading ?
            <Stack
                spacing={4}
                p="1rem"
                backgroundColor={colorMode === 'light' ? "whiteAlpha.900" : "whiteAlpha.100"}
                boxShadow="md"
              >
              <Center>
              <TradingSpinner size="40px" />
              </Center>
            </Stack>
          :
          <form>
            <Stack
              spacing={4}
              p="1rem"
              backgroundColor={colorMode === 'light' ? "whiteAlpha.900" : "whiteAlpha.100"}
              boxShadow="md"
            >
              <Flex justifyContent="space-between" alignItems="center">
                <Heading fontSize="xl" fontWeight="bold" fontFamily="'Open Sans', sans-serif" color={colorMode === 'light' ? 'gray.700' : 'gray.200'}>Log Trade</Heading>
                <Button size="sm" variant="ghost" colorScheme="gray" borderRadius="md" onClick={handleClear}>Clear</Button>
              </Flex>
              <Box display="flex">
                <FormControl>
                  <FormLabel fontSize="xs" mb={1} ml={1}>
                    Trade Type *
                  </FormLabel>
                  <Select value={trade_type} placeholder='Select Trade Type' onChange={(e) => setTradeType(e.target.value)}>
                    <option>Swing Trade</option>
                    <option>Day Trade</option>
                  </Select>
                </FormControl>
                <FormControl>
                  <FormLabel fontSize="xs" mb={1} ml={1}>
                    Security Type *
                  </FormLabel>
                  <Select id="optionsSelection" value={security_type} placeholder='Select Security Type' onChange={(e) => {changeShowOptions(e.target.value); setSecurityType(e.target.value)}}>
                    <option>Options</option>
                    <option>Shares</option>
                  </Select>
                </FormControl>
                <FormControl>
                  <FormLabel fontSize="xs" mb={1} ml={1}>
                    Direction *
                  </FormLabel>
                  <Select value={trade_direction} placeholder='Select Direction' onChange={(e) => {setTradeDirection(e.target.value)}}>
                    <option>Long</option>
                    <option>Short</option>
                    <option>Call</option>
                    <option>Put</option>
                  </Select>
                </FormControl>
                <FormControl>
                  <FormLabel fontSize="xs" mb={1} ml={1}>
                    Ticker *
                  </FormLabel>
                  <div className="ticker-search">
                    <Input type="text" value={selectedValue ? selectedValue : searchValue} onChange={handleInputChange} onClick={handleInputClick}/>
                    {isDropdownOpen && (
                      <ul className={colorMode === 'light' ? "search-dropdown" : "search-dropdown search-dropdown-dark"}>
                        {isLoading ? (
                          <div>Loading...</div>
                        ) : (
                          searchResultItems
                        )}
                      </ul>
                    )}
                  </div>
                </FormControl>
              </Box>
              
              {/* Row 2 — 3 fields: Expiry, Strike, Date Trade was Closed
                  Expiry + Strike are options-only and collapse out for Shares. */}
              <Box display="flex">
              <FormControl display={visib ? "block" : "none"}>
                <FormLabel fontSize="xs" mb={1} ml={1}>
                  Expiry (Options Only) *
                </FormLabel>
                <Input
                    value={expiry}
                    type="date"
                    max="3900-12-31"
                    min="1900-01-01"
                    onChange={(e) => setExpiry(e.target.value)}
                />
              </FormControl>

              <FormControl display={visib ? "block" : "none"}>
                <FormLabel fontSize="xs" mb={1} ml={1}>
                  Strike Price (Options Only) *
                </FormLabel>
                <InputGroup>
                  <Input
                    value={strike}
                    type="name"
                    onChange={(e) => setStrike(e.target.value)}
                  />
                </InputGroup>
              </FormControl>

              <FormControl>
                <FormLabel fontSize="xs" mb={1} ml={1}>
                  Date Trade was Closed *
                </FormLabel>
                <Input
                    value={trade_date}
                    type="date"
                    max={maxDate}
                    min="1900-01-01"
                    onChange={(e) => setTradeDate(e.target.value)}
                />
              </FormControl>
              </Box>

              {/* Row 3 — 3 fields: Average Cost, # of Units, R/R */}
              <Box display="flex">
              <FormControl>
                  <FormLabel fontSize="xs" mb={1} ml={1}>
                    Average Cost *
                  </FormLabel>
                  <Input
                    value={buy_value}
                    type="name"
                    onChange={(e) => setBuyValue(e.target.value)}
                  />
              </FormControl>

              <FormControl>
                  <FormLabel fontSize="xs" mb={1} ml={1}>
                    # of Units *
                  </FormLabel>
                  <Input
                    value={units}
                    type="name"
                    onChange={(e) => setUnits(e.target.value)}
                  />
              </FormControl>

              <FormControl>
                  <FormLabel fontSize="xs" mb={1} ml={1}>
                    Risk/Reward Ratio (R:R) *
                  </FormLabel>
                  <HStack>
                  <NumberInput
                    onChange={(stringValue) => setRisk(stringValue)}
                    value = {risk}
                    min={1}
                    max={200}
                    inputMode='text'
                  >
                    <NumberInputField />
                    <NumberInputStepper>
                      <NumberIncrementStepper />
                      <NumberDecrementStepper />
                    </NumberInputStepper>
                  </NumberInput>
                  <Text>
                    :
                  </Text>
                  <NumberInput
                    onChange={(stringValue) => setReward(stringValue)}
                    value = {reward}
                    min={1}
                    max={200}
                    inputMode='text'
                  >
                    <NumberInputField />
                    <NumberInputStepper>
                      <NumberIncrementStepper />
                      <NumberDecrementStepper />
                    </NumberInputStepper>
                  </NumberInput>
                  </HStack>
              </FormControl>
              </Box>

              {/* Row 4 — 3 fields: PNL, Fees, % W/L */}
              <Box display="flex">
              <FormControl>
                  <FormLabel fontSize="xs" mb={1} ml={1}>
                    {fees && parseFloat(fees) > 0 ? "PNL (gross) *" : "PNL *"}
                  </FormLabel>
                  <Input
                    value={pnl}
                    type="name"
                    onChange={(e) => setPNL(e.target.value)}
                  />
                  {fees && parseFloat(fees) > 0 && pnl !== "" && !isNaN(parseFloat(pnl)) && (
                    <Text fontSize="xs" color="gray.500" mt={1} ml={1}>
                      Net PNL: {(parseFloat(pnl) - parseFloat(fees)).toFixed(2)}
                    </Text>
                  )}
              </FormControl>

              <FormControl>
                  <FormLabel fontSize="xs" mb={1} ml={1}>
                    <HStack spacing={1}>
                      <span>Fees</span>
                      <Tooltip
                        label="Total commissions + regulatory fees for this trade. PnL above will be saved as gross − fees."
                        placement="top"
                        hasArrow
                      >
                        <span>
                          <Icon as={IoInformationCircleOutline} boxSize={3.5} color="gray.500" cursor="help" />
                        </span>
                      </Tooltip>
                    </HStack>
                  </FormLabel>
                  <Input
                    value={fees}
                    type="number"
                    placeholder="0"
                    onChange={(e) => setFees(e.target.value)}
                  />
              </FormControl>

              <FormControl>
                  <FormLabel fontSize="xs" mb={1} ml={1}>
                    % Win or Loss *
                  </FormLabel>
                  <Input
                    value={percent_wl}
                    type="name"
                    readOnly
                    placeholder={"0.00"}
                    value={percent_wl}
                  />
              </FormControl>
              </Box>

              <FormControl>
                  <FormLabel fontSize="xs" mb={1} ml={1}>
                    Comments *
                  </FormLabel>
                  <Textarea value={comments} placeholder='Reflect on your Trade...' onChange={(e) => setComments(e.target.value)}/>
              </FormControl>
              <FormControl>
                  <FormLabel fontSize="xs" mb={1} ml={1}>
                    Tags
                  </FormLabel>
                  <Wrap mb={2}>
                    {tags.map((tag) => {
                      const isSelected = selectedTagIds.includes(tag.tag_id);
                      const hasCustomColor = tag.color && tag.color !== '#3182CE';
                      return (
                        <WrapItem key={tag.tag_id}>
                          <Tag
                            size="md"
                            variant={isSelected ? "solid" : "outline"}
                            {...(hasCustomColor
                              ? {
                                  bg: isSelected ? tag.color : 'transparent',
                                  color: isSelected ? 'white' : tag.color,
                                  borderColor: tag.color,
                                }
                              : { colorScheme: isSelected ? 'blue' : 'gray' }
                            )}
                            cursor="pointer"
                            onClick={() => handleToggleTag(tag.tag_id)}
                          >
                            <TagLabel>{tag.name}</TagLabel>
                            {isSelected && (
                              <TagCloseButton onClick={(e) => { e.stopPropagation(); handleToggleTag(tag.tag_id); }} />
                            )}
                          </Tag>
                        </WrapItem>
                      );
                    })}
                  </Wrap>
                  <HStack>
                    <Input
                      size="sm"
                      placeholder="Create new tag..."
                      value={newTagName}
                      onChange={(e) => setNewTagName(e.target.value)}
                      onKeyDown={(e) => { if (e.key === 'Enter') { e.preventDefault(); handleAddTag(); } }}
                    />
                    <input
                      type="color"
                      value={newTagColor}
                      onChange={(e) => setNewTagColor(e.target.value)}
                      className="color-picker-input"
                    />
                    <Button size="sm" colorScheme="blue" onClick={handleAddTag}>Add</Button>
                  </HStack>
              </FormControl>
              <AccountValueSyncToggle
                isChecked={accountValueAddEnable}
                onChange={(e) => handleCheckboxChange(e, "Add")}
                actionLabel="this new trade"
                pl={2}
              />
              <Button
                borderRadius="md"
                variant="solid"
                colorScheme="blue"
                width="full"
                onClick={handleSubmit}
              >
                Create Entry
              </Button>
              <Button
                borderRadius="md"
                variant="solid"
                colorScheme="gray"
                width="full"
                onClick={handleCancel}
              >
                Cancel
              </Button>
            </Stack>
          </form>
        }
        </Box>
      </VStack>
      {tradeLogged}
      <AlertDialog
        motionPreset='slideInBottom'
        isOpen={reviewPopup}
        leastDestructiveRef={cancelRef}
        onClose={handleSkipReview}
        isCentered={true}
        size='md'
        closeOnOverlayClick={false}
      >
        <AlertDialogOverlay>
        <AlertDialogContent>
          <AlertDialogHeader fontSize='lg' fontWeight='bold'>
            Post-Trade Review
          </AlertDialogHeader>

          <AlertDialogBody>
            <FormControl mb={3}>
              <FormLabel fontSize="xs" mb={1} ml={1}>
                Setup Type
              </FormLabel>
              <Input
                placeholder="e.g. Breakout, Reversal, Momentum"
                value={reviewSetupType}
                onChange={(e) => setReviewSetupType(e.target.value)}
              />
            </FormControl>
            <FormControl mb={3}>
              <FormLabel fontSize="xs" mb={1} ml={1}>
                Did you follow your plan?
              </FormLabel>
              <Select
                placeholder="-- Select --"
                value={reviewFollowedPlan}
                onChange={(e) => setReviewFollowedPlan(e.target.value)}
              >
                <option value="true">Yes</option>
                <option value="false">No</option>
              </Select>
            </FormControl>
            <FormControl mb={3}>
              <FormLabel fontSize="xs" mb={1} ml={1}>
                Emotional State
              </FormLabel>
              <Select
                placeholder="-- Select --"
                value={reviewEmotionalState}
                onChange={(e) => setReviewEmotionalState(e.target.value)}
              >
                <option value="calm">Calm</option>
                <option value="anxious">Anxious</option>
                <option value="excited">Excited</option>
                <option value="fearful">Fearful</option>
                <option value="revenge">Revenge</option>
              </Select>
            </FormControl>
            <FormControl mb={3}>
              <FormLabel fontSize="xs" mb={1} ml={1}>
                What would you do differently?
              </FormLabel>
              <Textarea
                placeholder="Notes on the trade..."
                value={reviewNotes}
                onChange={(e) => setReviewNotes(e.target.value)}
                rows={3}
              />
            </FormControl>
            <FormControl>
              <FormLabel fontSize="xs" mb={1} ml={1}>
                Chart Screenshot (optional)
              </FormLabel>
              <input
                type="file"
                accept="image/*"
                hidden
                id="logtrade-review-screenshot"
                onChange={(e) => setReviewScreenshot(e.target.files[0] || null)}
              />
              <Button
                variant="outline"
                colorScheme="blue"
                borderRadius="md"
                size="sm"
                onClick={() => document.getElementById('logtrade-review-screenshot').click()}
              >
                Choose File
              </Button>
              {reviewScreenshot && <Text fontSize="xs" color="gray.500" mt={1}>{reviewScreenshot.name}</Text>}
            </FormControl>
          </AlertDialogBody>
          <AlertDialogFooter paddingTop={6}>
            <Button ref={cancelRef} minWidth='50px' borderRadius="md" onClick={handleSkipReview}>
              Skip
            </Button>
            <Button colorScheme='blue' minWidth='50px' borderRadius="md" onClick={handleSubmitReview} ml={3}>
              Save Review
            </Button>
          </AlertDialogFooter>
        </AlertDialogContent>
        </AlertDialogOverlay>
      </AlertDialog>
      <AlertDialog
        motionPreset='slideInBottom'
        isOpen={logAnotherPopup}
        leastDestructiveRef={cancelRef}
        onClose={e => handleAnswerNo(e)}
        isCentered={true}
        closeOnOverlayClick={false}
      >
        <AlertDialogOverlay>
        <AlertDialogContent>
          <AlertDialogHeader fontSize='lg' fontWeight='bold'>
            Trade Logged Successfully
          </AlertDialogHeader>

          <AlertDialogBody>
            Would You Like to Log Another?
          </AlertDialogBody>

          <AlertDialogFooter>
            <Button colorScheme='blue' borderRadius="md" onClick={e => handleAnswerYes(e)}>
              Yes
            </Button>
            <Button ref={cancelRef} colorScheme='gray' borderRadius="md" onClick={e => handleAnswerNo(e)} ml={3}>
              No
            </Button>
          </AlertDialogFooter>
        </AlertDialogContent>
        </AlertDialogOverlay>
      </AlertDialog>
    </Flex>
  );
}
